import React, { FormEvent, useRef, useState } from 'react';

import { SVGIcon } from '../wrappers/SVGIcon';

import { Icons } from '../../data/Assets';

interface IAuthInputProps {
    label: string;
    type: string;
    isPasswordToggle?: boolean;
    name: string;
    id: string;
    placeholder: string;
    onChange: (e: any) => void;
    value: string;
    error: string | null;
    containerRef: React.MutableRefObject<HTMLDivElement | null>;
}
export const AuthInput = (props: IAuthInputProps) => {
    const { label, type, isPasswordToggle, name, id, placeholder, onChange, value, error, containerRef } = props;
    const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement | null>(null);
    const togglePassWordVisibility = (e: FormEvent) => {
        e.preventDefault();
        if (isPasswordToggle) setIsPasswordVisible(!isPasswordVisible);
    }

    return (
        <div className='imm_consultant__auth_input_container' ref={containerRef}>
            <div className='label__cont'>
                <label htmlFor={id}>{label}</label>
            </div>
            <div className='input_group'>
                <input
                    type={type === 'password' && isPasswordVisible ? 'text' : type}
                    name={name}
                    id={id}
                    placeholder={placeholder}
                    onChange={onChange}
                    value={value}
                    ref={inputRef}
                />
                {type === 'password' &&
                    <button type='button' className='password_toggle_btn' onClick={togglePassWordVisibility}>
                        <SVGIcon src={isPasswordVisible ? Icons.EyeFill : Icons.EyeOffFill} />
                    </button>
                }
                {error &&
                    <div className='imm_consultant__input_error__cont'>
                        <span className='input_error'>{error}</span>
                    </div>
                }
            </div>
        </div>
    );
};
